import { categories, categoryDataTables } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import { Link } from 'react-router-dom';

interface CategoryPageProps {
  slug: string;
}

export default function CategoryPage({ slug }: CategoryPageProps) {
  const category = categories.find((c) => c.slug === slug);
  const dataTable = categoryDataTables[slug];
  const categoryArticles = getArticlesByCategory(slug);

  if (!category) {
    return null;
  }

  return (
    <div>
      <div className="bg-background-100 border-b border-background-200/70">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="flex items-center gap-4 mb-6 flex-wrap">
            <div className="w-14 h-14 flex items-center justify-center bg-primary-100 rounded-xl">
              <i className={`${category.icon} text-primary-600 text-2xl`}></i>
            </div>
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                {category.name}
              </h2>
              <p className="text-sm text-foreground-500 mt-1">{category.description}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 flex-wrap">
            <div className="flex items-center gap-1 px-1 py-1 bg-background-200/70 rounded-full">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
        {dataTable ? (
          <div className="mb-12">
            <h3 className="text-lg font-semibold text-foreground-900 mb-5">
              最新开奖数据
            </h3>
            <div className="overflow-x-auto bg-background-50 border border-background-200/70 rounded-xl">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200/70 bg-background-100">
                    {dataTable.headers.map((header, idx) => (
                      <th
                        key={idx}
                        className="px-5 py-3 text-left text-xs font-medium text-foreground-500 whitespace-nowrap"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dataTable.rows.map((row, rowIdx) => (
                    <tr
                      key={rowIdx}
                      className="border-b border-background-100 hover:bg-background-50 transition-colors"
                    >
                      <td className="px-5 py-4 text-foreground-700 font-medium">
                        {row.period}
                      </td>
                      <td className="px-5 py-4 text-foreground-500">{row.date}</td>
                      {category.slug === 'shuangseqiu' ? (
                        <>
                          <td className="px-5 py-4">
                            <div className="flex items-center gap-1.5">
                              {row.numbers.slice(0, 6).map((num, nIdx) => (
                                <span
                                  key={nIdx}
                                  className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold"
                                >
                                  {num}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className="px-5 py-4">
                            <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                              {row.numbers[6]}
                            </span>
                          </td>
                        </>
                      ) : category.slug === 'daletou' ? (
                        <>
                          <td className="px-5 py-4">
                            <div className="flex items-center gap-1.5">
                              {row.numbers.slice(0, 5).map((num, nIdx) => (
                                <span
                                  key={nIdx}
                                  className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold"
                                >
                                  {num}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className="px-5 py-4">
                            <div className="flex items-center gap-1.5">
                              {row.numbers.slice(5).map((num, nIdx) => (
                                <span
                                  key={nIdx}
                                  className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold"
                                >
                                  {num}
                                </span>
                              ))}
                            </div>
                          </td>
                        </>
                      ) : category.slug === 'fucai3d' ? (
                        <>
                          <td className="px-5 py-4">
                            <div className="flex items-center gap-1.5">
                              {row.numbers.slice(0, 3).map((num, nIdx) => (
                                <span
                                  key={nIdx}
                                  className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold"
                                >
                                  {num}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className="px-5 py-4">
                            <div className="flex items-center gap-1.5">
                              {row.numbers.slice(3).map((num, nIdx) => (
                                <span
                                  key={nIdx}
                                  className="w-7 h-7 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-700 text-xs font-bold"
                                >
                                  {num}
                                </span>
                              ))}
                            </div>
                          </td>
                        </>
                      ) : category.slug === 'pailiesan' ? (
                        <>
                          <td className="px-5 py-4">
                            <div className="flex items-center gap-1.5">
                              {row.numbers.slice(0, 3).map((num, nIdx) => (
                                <span
                                  key={nIdx}
                                  className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold"
                                >
                                  {num}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className="px-5 py-4">
                            <span className="text-foreground-700 font-medium">{row.numbers[3]}</span>
                          </td>
                        </>
                      ) : (
                        <td className="px-5 py-4">
                          <div className="flex items-center gap-1.5">
                            {row.numbers.map((num, nIdx) => (
                              <span
                                key={nIdx}
                                className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold"
                              >
                                {num}
                              </span>
                            ))}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : null}

        {categoryArticles.length > 0 ? (
          <div>
            <h3 className="text-lg font-semibold text-foreground-900 mb-5">
              {category.name}相关资讯
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categoryArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
                >
                  <div className="relative h-40 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 flex-1 flex flex-col">
                    <h4 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h4>
                    <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                      <span className="text-xs text-foreground-400">{article.date}</span>
                      <span className="text-xs text-foreground-400">{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ) : null}

        <div className="mt-10 p-6 bg-primary-50 border border-primary-100 rounded-xl text-center">
          <p className="text-sm text-primary-700">
            想获取更多{category.name}数据分析？立即注册彩客网账号，解锁智能分析预测功能
          </p>
          <Link
            to="/about"
            className="inline-block mt-3 px-6 py-2 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            免费注册
          </Link>
        </div>
      </div>
    </div>
  );
}